import { render, staticRenderFns } from "./ForumThreadListItem.vue?vue&type=template&id=1d337e3f&"
import script from "./ForumThreadListItem.vue?vue&type=script&lang=js&"
export * from "./ForumThreadListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d337e3f')) {
      api.createRecord('1d337e3f', component.options)
    } else {
      api.reload('1d337e3f', component.options)
    }
    module.hot.accept("./ForumThreadListItem.vue?vue&type=template&id=1d337e3f&", function () {
      api.rerender('1d337e3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/forum/ForumThreadListItem.vue"
export default component.exports